// components/Layout/Topbar/MenuButton.jsx
import React from "react";
import { IoMdMenu } from "react-icons/io";

const MenuButton = ({ openSidebar, setOpenSidebar }) => {
  return (
    <button
      type="button"
      className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
      onClick={() => setOpenSidebar(!openSidebar)}
      aria-label="Toggle sidebar"
    >
      <IoMdMenu className="w-6 h-6" />
    </button>
  );
};

export default MenuButton;